import { render, staticRenderFns } from "./WorkingPortfolioNew.vue?vue&type=template&id=4f56b912&"
import script from "./WorkingPortfolioNew.vue?vue&type=script&lang=js&"
export * from "./WorkingPortfolioNew.vue?vue&type=script&lang=js&"
import style0 from "./WorkingPortfolioNew.vue?vue&type=style&index=0&id=4f56b912&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports